<div class="modal-content" *ngIf="event">
  <button type="button" class="close" mat-dialog-close aria-label="Close"><span aria-hidden="true">×</span></button>
  <div>
      <span class="modal-title title" id="modallabel">Confirmar remoção de evento</span>
  </div>
  <div class="modal-body text-left">
      <span *ngIf="errorMessage">{{ errorMessage }}</span>
      <span *ngIf="!errorMessage" class="desc">Deseja realmente remover a evento "<strong>{{event?.title}}</strong>"?</span>
  </div>
  <div class="modal-footer" *ngIf="!done">
      <button type="button" class="btn btn-sm btn-default btn-light" mat-dialog-close data-bs-dismiss="modal">Cancelar</button>
      <button type="button" class="btn btn-info apply" (click)="onRemoveEvent(event)" data-bs-dismiss="modal">Remover</button>
  </div>
</div>

<div class="modal-content" *ngIf="program">
  <div class="modal-header">
      <h4 class="modal-title" id="modallabel">Confirmar remoção de programa</h4>
      <button type="button" class="close" mat-dialog-close aria-label="Close"><span aria-hidden="true">×</span></button>
  </div>
  <div class="modal-body text-left">
      <span *ngIf="errorMessage">{{ errorMessage }}</span>
      <span *ngIf="!errorMessage">Deseja realmente remover o programa "<strong>{{program?.programName}}</strong>"?</span>
  </div>
   <div class="modal-footer" *ngIf="!done">
      <button type="button" class="btn btn-sm btn-default" mat-dialog-close data-bs-dismiss="modal">Cancelar</button>
      <button type="button" class="btn btn-info" (click)="onRemoveProgram(program)" data-bs-dismiss="modal">Remover</button>
  </div>
</div>

<div *ngIf="tip" class="modal-content">
    <button type="button" class="close" mat-dialog-close aria-label="Close"><span aria-hidden="true">×</span></button>
    <div>
        <span class="modal-title title" id="modallabel">Confirmar remoção de conteúdo</span>
    </div>
    <div class="modal-body text-left">
        <span *ngIf="errorMessage">{{ errorMessage }}</span>
        <span *ngIf="!errorMessage">Deseja realmente remover o conteúdo "<strong>{{tip?.postTitle}}</strong>"?</span>
    </div>
    <div class="modal-footer" *ngIf="!done">
        <button type="button" class="btn btn-sm btn-default btn-light" mat-dialog-close data-bs-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-info apply" (click)="onRemoveTip(tip)" data-bs-dismiss="modal">Remover</button>
    </div>
</div>

<div *ngIf="informativeId" class="modal-content">
    <button type="button" class="close" mat-dialog-close aria-label="Close"><span aria-hidden="true">×</span></button>
    <div>
        <span class="modal-title title" id="modallabel">Confirmar remoção de informativo</span>
    </div>
    <div class="modal-body text-left">
        <span *ngIf="errorMessage">{{ errorMessage }}</span>
        <span *ngIf="!errorMessage">Deseja realmente remover o informativo?</span>
    </div>
    <div class="modal-footer" *ngIf="!done">
        <button type="button" class="btn btn-sm btn-default btn-light" mat-dialog-close data-bs-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-info apply" (click)="onRemoveInformative(informativeId)" data-bs-dismiss="modal">Remover</button>
    </div>
</div>

<div class="modal-content" *ngIf="wellHub">
  <div class="modal-header">
      <h4 class="modal-title" id="modallabel">Confirmar remoção do Wellhub</h4>
      <button type="button" class="close" mat-dialog-close aria-label="Close"><span aria-hidden="true">×</span></button>
  </div>
  <div class="modal-body text-left">
      <span *ngIf="errorMessage">{{ errorMessage }}</span>
      <span *ngIf="!errorMessage">Deseja realmente remover o Wellhub "<strong>{{wellHub?.wellHubName}}</strong>"?</span>
  </div>
  <div class="modal-footer" *ngIf="!done">
      <button type="button" class="btn btn-sm btn-default" mat-dialog-close data-bs-dismiss="modal">Cancelar</button>
      <button type="button" class="btn btn-info" (click)="onRemoveWellHub(wellHub)" data-bs-dismiss="modal">Remover</button>
  </div>
</div>
<div class="modal-content" *ngIf="course">
  <div class="modal-header">
      <h4 class="modal-title" id="modallabel">Confirmar remoção do Curso</h4>
      <button type="button" class="close" mat-dialog-close aria-label="Close"><span aria-hidden="true">×</span></button>
  </div>
  <div class="modal-body text-left">
      <span *ngIf="errorMessage">{{ errorMessage }}</span>
      <span *ngIf="!errorMessage">Deseja realmente remover o Curso "<strong>{{course?.name}}</strong>"?</span>
  </div>
  <div class="modal-footer" *ngIf="!done">
      <button type="button" class="btn btn-sm btn-default" mat-dialog-close data-bs-dismiss="modal">Cancelar</button>
      <button type="button" class="btn btn-info" (click)="onRemoveCourse()">Remover</button>
  </div>
</div>


<div class="modal-content" *ngIf="businessPartner">
  <div class="modal-header">
    <h4 class="modal-title" id="modallabel">Confirmar remoção do Parceiro</h4>
    <button type="button" class="close" mat-dialog-close aria-label="Close"><span aria-hidden="true">×</span></button>
  </div>
  <div class="modal-body text-left">
    <span *ngIf="errorMessage">{{ errorMessage }}</span>
    <span *ngIf="!errorMessage">Deseja realmente remover o Parceiro "<strong>{{businessPartner?.name}}</strong>"?</span>
  </div>
  <div class="modal-footer" *ngIf="!done">
    <button type="button" class="btn btn-sm btn-default" mat-dialog-close data-bs-dismiss="modal">Cancelar</button>
    <button type="button" class="btn btn-info" (click)="onRemoveBusinessPartner(businessPartner)" data-bs-dismiss="modal">Remover</button>
  </div>
</div>

<div class="modal-content" *ngIf="marketplace">
  <div class="modal-header">
    <h4 class="modal-title" id="modallabel">Confirmar remoção da Loja</h4>
    <button type="button" class="close" mat-dialog-close aria-label="Close"><span aria-hidden="true">×</span></button>
  </div>
  <div class="modal-body text-left">
    <span *ngIf="errorMessage">{{ errorMessage }}</span>
    <span *ngIf="!errorMessage">Deseja realmente remover a Loja "<strong>{{marketplace?.name}}</strong>"?</span>
  </div>
  <div class="modal-footer" *ngIf="!done">
    <button type="button" class="btn btn-sm btn-default" mat-dialog-close data-bs-dismiss="modal">Cancelar</button>
    <button type="button" class="btn btn-info" (click)="onRemoveMarketplace(marketplace)" data-bs-dismiss="modal">Remover</button>
  </div>
</div>


<div class="modal-content" *ngIf="benefit">
  <div class="modal-header">
      <h4 class="modal-title" id="modallabel">Confirmar remoção de Benefício</h4>
      <button type="button" class="close" mat-dialog-close aria-label="Close"><span aria-hidden="true">×</span></button>
  </div>
  <div class="modal-body text-left">
      <span *ngIf="errorMessage">{{ errorMessage }}</span>
      <span *ngIf="!errorMessage">Deseja realmente remover a benefício "<strong>{{benefit?.benefitName}}</strong>"?</span>
  </div>
  <div class="modal-footer" *ngIf="!done">
      <button type="button" class="btn btn-sm btn-default" mat-dialog-close data-bs-dismiss="modal">Cancelar</button>
      <button type="button" class="btn btn-info" (click)="onRemoveBenefit(benefit)" data-bs-dismiss="modal">Remover</button>
  </div>
</div>

